import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FlavourCard3D from "./FlavourCard3D";
import { Box, Container, Grid, Typography, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const AllFlavoursPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { products, title } = location.state || {};

  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  const isMobile = screenWidth < 768;

  const cardWidth = isMobile ? screenWidth / 2.2 : screenWidth / 5.5;
  const cardHeight = isMobile ? screenHeight / 5 : screenHeight / 2;

  const slugify = (text) =>
    text
      ?.toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "");

  const handleCardClick = (item) => {
    const flavourSlug = slugify(item?.flavour_name);
    navigate(`/listing/${flavourSlug}`);
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#f9f9f9", py: 4 }}>
      <Container maxWidth="1200">
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            mb: isMobile ? 2 : 4,
            mt: isMobile ? "20px" : "5px",
          }}
        >
          <Typography
            variant="body1"
            sx={{
              color: "#666",
              cursor: "pointer",
              fontWeight: 400,
              fontSize: { xs: 14, md: 16 },
              "&:hover": {
                textDecoration: "underline",
              },
            }}
            onClick={() => navigate("/")} // 🔙 Navigate to Home
          >
            Home
          </Typography>

          <Typography variant="body1" sx={{ color: "#999", fontWeight: 400 }}>
            &gt;
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontWeight: 600,
              color: "#1B1B1B",
              fontSize: { xs: 14, md: 16 },
              textTransform: "capitalize",
            }}
          >
            {title || "All Flavours"}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              fontSize: { xs: 20, md: 28 },
            }}
          >
            {title || "All Flavours"}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#888",
              fontWeight: 500,
              fontSize: { xs: 14, md: 16 },
              mt: 0.5,
            }}
          >
            ({products?.length || 0} items)
          </Typography>
        </Box>

        {/* Grid Layout */}
        <Grid container spacing={{ xs: 2, md: 3 }}>
          {products?.map((item, index) => (
            <Grid
              item
              xs={6}
              sm={4}
              md={3}
              key={index}
              style={{ marginTop: "30px" }}
            >
              <Box
                sx={{
                  bgcolor: "white",
                  borderRadius: 3,
                  p: 1.5,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-8px)",
                    boxShadow: "0 8px 16px rgba(0,0,0,0.12)",
                  },
                }}
                onClick={() => handleCardClick(item)}
              >
                {/* 3D Card */}
                <Box sx={{ mb: 1 }}>
                  <FlavourCard3D item={item} width="100%" height={cardHeight} />
                </Box>

                {/* Text Content */}
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    sx={{
                      fontSize: { xs: 14, md: 16 },
                      fontWeight: 600,
                      color: "#1B1B1B",
                      mb: 0.5,
                    }}
                  >
                    {item?.flavour_name}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: { xs: 12, md: 14 },
                      color: "#666",
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {item?.flavour_description}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>

        {/* Empty State */}
        {!products || products.length === 0 ? (
          <Box
            sx={{
              textAlign: "center",
              py: 8,
            }}
          >
            <Typography variant="h6" color="text.secondary">
              No flavours available
            </Typography>
          </Box>
        ) : null}
      </Container>
    </Box>
  );
};

export default AllFlavoursPage;
